import o from "./setPrototypeOf.js";
function i(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && o(e, t);
}
export {
  i as default
};
//# sourceMappingURL=inherits.js.map
